import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader() {
  return (
    <div className="fullPageLoader">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          '& > :not(style)': {
            m: 1
          }
        }}
      >
        <CircularProgress />
      </Box>
    </div>
  );
}
